import * as React from 'react';
export default function useSelectTriggerControl(elements, open, triggerOpen) {
    const propsRef = React.useRef(null);
    propsRef.current = {
        elements: elements.filter(e => e),
        open,
        triggerOpen
    };
    React.useEffect(() => {
        function onGlobalMouseDown(event) {
            let target = event.target;
            if (target.shadowRoot && event.composed) {
                target = (event.composedPath()[0] || target);
            }
            if (propsRef.current.open
                && propsRef.current.elements.every(element => !element.contains(target) && element !== target)) {
                // Should trigger close
                propsRef.current.triggerOpen(false);
            }
        }
        window.addEventListener('mousedown', onGlobalMouseDown);
        return () => window.removeEventListener('mousedown', onGlobalMouseDown);
    }, []);
}
